import { styled } from '@mui/material'
import Typography from './Typography'
import { shouldForwardProp } from '../util/helpers'

interface ItemContainerProps extends Record<string, unknown> {
  wrap?: boolean
}

export const ItemContainer = styled('div', {
  shouldForwardProp: (prop) => shouldForwardProp<ItemContainerProps>(['wrap'], prop),
})<ItemContainerProps>(({ theme, wrap }) => ({
  display: 'flex',

  [theme.breakpoints.down('sm')]: {
    columnGap: '8px',
    width: 'unset',
  },

  ...(!wrap
    ? {
        flexDirection: 'column',
      }
    : {
        flexDirection: 'row',
        flexWrap: 'wrap',
      }),
}))

export const ItemLabel = styled(Typography)(({ theme, color, align }) => ({
  color: theme.colors[color ?? 'grey700'],
  textAlign: align,
  whiteSpace: 'nowrap',
}))

export const ItemValue = styled(Typography)(({ theme, color, align }) => ({
  color: theme.colors[color ?? 'grey700'],
  textAlign: align,
}))
